import LearnLayout from '@/components/Learn/LearnLayout';
import { ThemeProvider } from '@/context/ThemeContext';

export default function LearnRouteLayout() {
  return (
    <ThemeProvider forceTheme="white" scoped>
      <LearnLayout />
    </ThemeProvider>
  );
}
